import axios from "axios";
import {TTP_API_URL} from "Config";
import { updateSourceToken } from 'utils';


let fetchPaymentLogsSourceToken;
let getCountPaymentLogsBySubscriptionSourceToken;

export const fetchPaymentLogs = (token, sourceToken, params) => {

  fetchPaymentLogsSourceToken = updateSourceToken(fetchPaymentLogsSourceToken, sourceToken);

  const date = params.date ? params.date : null;
  const issuerId = params.issuerId ? params.issuerId : null;
  const status = params.status ? params.status : 'ALL';
  const userId = params.userId ? params.userId : null;
  const subscriptionId = params.subscriptionId ? params.subscriptionId : null;
  const sort = params.sort ? params.sort : [{property: "createdAt", dir: "desc"}];

  let filter = [];
  const requestUrl = `${TTP_API_URL}/billing/payment-log`;

  if(date !== null)
    filter.push({
      property: 'paymentLogDate',
      value: date,
      operator: 'in'
    });

  if(issuerId !== null)
    filter.push({
      property: 'issuer',
      value: issuerId,
      operator: 'eq'
    });

  if(status !== 'ALL')
    filter.push({
      property: 'type',
      value: status,
      operator: 'eq'
    });

  if(userId !== null)
    filter.push({
      property: 'user',
      value: userId,
      operator: 'eq'
    });

  if(subscriptionId !== null)
    filter.push({
      property: 'subscription',
      value: subscriptionId,
      operator: 'eq'
    });

  return axios.get(requestUrl, {
    cancelToken: fetchPaymentLogsSourceToken.token,
    params: {
      access_token: token,
      fields: "*, order",
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
    }
  })
};


export const getCountPaymentLogsBySubscription = (token, sourceToken, params) => {

  let filter = [];
  const requestUrl = `${TTP_API_URL}/billing/payment-log/get-count-by-status`;

  getCountPaymentLogsBySubscriptionSourceToken = updateSourceToken(getCountPaymentLogsBySubscriptionSourceToken, sourceToken);


  const date = params.date ? params.date : null;
  const subscriptionId = params.subscriptionId ? params.subscriptionId : null;

  return axios.get(requestUrl, {
    cancelToken: getCountPaymentLogsBySubscriptionSourceToken.token,
    params: {
      access_token: token,
      year: date,
      subscriptionId,
    }
  })
};

export const downloadInvoice = (token, paymentLogId) => {

  const requestUrl = `${TTP_API_URL}/billing/payment-log/display-invoice-pdf/${paymentLogId}`;

  window.open(`${requestUrl}?access_token=${token}`, '_blank');
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/paymentLogs.js